import React from "react";

import { OverlayTrigger, Popover } from "react-bootstrap";
import moment from "moment";
import Select from "react-select";

import Toggle from "react-toggle";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faBan,
  faExclamationTriangle,
  faChevronDown,
  faChevronUp,
  faEyeSlash,
  faCheck
} from "@fortawesome/free-solid-svg-icons";

import { Icon, ButtonGroup, Button, Accordion } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import DistributionChart from "components/Gallery/Charts/DistributionChart";
import OutcomeChart from "components/Gallery/Charts/OutcomeChart";

import TransformContainer from "containers/Dataset/Transform";
import ExportJSONContainer from "containers/Dataset/ExportJSON";
import DatasetSchemaChangesContainer from "containers/SchemaMonitor/DatasetSchemaChanges";

import FeedbackContainer from "containers/Gallery/Feedback";

import styles from "./style.module.css";

import HomeIcon from "images/EDG/HomeIcon.svg";
import NumberIcon from "images/EDG/123.svg";
import CategoryIcon from "images/EDG/abc.svg";
import WarnIcon from "images/EDG/WarnIcon.svg";
import LineageIcon from "images/EDG/LineageIcon.svg";
import ExploreIcon from "images/EDG/ExploreIcon.svg";
import ExploreIconWhite from "images/EDG/ExploreIconWhite.svg";
import AIReadyIcon from "images/EDG/AIReadyIcon.svg";
import CheckIcon from "images/EDG/CheckIcon.svg";
import DateIcon from "images/EDG/DateIcon.svg";
import CreateIcon from "images/EDG/CreateIcon.svg";
import HourglassIcon from "images/EDG/hourglass.svg";
import FilterIcon from "images/EDG/FilterIcon.svg";
import JoinIcon from "images/EDG/JoinIcon.svg";
import AibleIcon from "images/EDG/AibleIcon.svg";
import ScaleIcon from "images/EDG/ScaleIcon.svg";
import ABIcon from "images/EDG/ABIcon.svg";
import reportsIcon from "images/EDG/Charts/reports-icon.svg";
import BlueprintIcon from "images/tileIcons/blueprint.svg";

import { isEnabled } from "utils/featureFlags";

import { GALLERY_RIGHT_MODE, JOIN_TYPES } from "containers/Gallery/GalleryReducer";
import { REPORT_CHART_TYPES } from "containers/Report/ReportReducer";
import { VIEW_TYPE } from "containers/View/reducer";
import { parseWarningForEDG } from "containers/Home/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class Gallery extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sectionKey: "create",
      selectedOutcomes: {},
      fixMe: false,
      isExploreLoading: undefined,
      scaled: {},
      showAllStats: {},
      isChangeBlueprint: false
    };
  }

  getInertCount() {
    const { dataset, exploreOutcomes } = this.props;

    return (
      dataset &&
      dataset.fields &&
      Object.keys(dataset.fields).reduce(
        (a, f) =>
          a +
          (exploreOutcomes &&
          exploreOutcomes[f] !== true &&
          Object.keys(exploreOutcomes).filter((k) => exploreOutcomes[k] === true).length > 0 &&
          (dataset?.fields?.[dataset.outcome]?.inclusionProbabilities &&
            Object.keys(exploreOutcomes)
              .filter((k) => exploreOutcomes[k] === true)
              .reduce((a, b) => {
                const currProb = dataset.fields[b].inclusionProbabilities?.find((prob) =>
                  prob?.keys?.every((k) => k === f)
                )?.value;
                return a && (currProb === undefined || currProb < 0.5);
              }, true) === true) === true
            ? 1
            : 0),
        0
      )
    );
  }

  renderHeader() {
    const {
      id,
      dataset,
      isConsumer,
      isNext,
      history,
      rightMode,
      isExploring,
      exploreOutcomes,
      updateRightMode,
      updateType,
      changeDatasetName,
      canEdit,
      updateActiveTab,
      activeTab,
      ignored,
      outcomeSuccess,
      hasUpdatedOutcomeSuccess,
      updateTargetValue
    } = this.props;

    const { isAutoIgnore, isUpdatingTargetValue } = this.state;

    const evalColumns = exploreOutcomes ? Object.keys(exploreOutcomes).filter((o) => exploreOutcomes[o] === true) : [];

    const inertCount = this.getInertCount();

    const dIgnored = dataset?.transformations?.exclude_columns || [];
    let sIgnored = [];

    ignored &&
      Object.keys(ignored)
        .filter((i) => ignored[i] === true)
        .forEach((i) => {
          sIgnored.push(i);
        });

    return (
      <div className={isConsumer || isNext ? styles.gHeaderConsumer : styles.gHeader}>
        {isNext && (
          <div className={styles.headerTitle}>
            <div className={styles.headerTop}>{dataset ? dataset.label : "..."}</div>
            <div className={styles.headerBot}>
              {"Last Updated: " + moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a")}
            </div>
            <div className={styles.headerTop}>Dataset id: {dataset ? dataset.id : "..."}</div>
          </div>
        )}
        {hasUpdatedOutcomeSuccess &&
          outcomeSuccess?.[dataset.target]?.value &&
          dataset?.fields?.[dataset?.outcome].data?.length > 2 &&
          !isNext && (
            <div className={styles.showMore}>
              <Button
                disabled={isUpdatingTargetValue}
                onClick={() => {
                  updateTargetValue(outcomeSuccess[dataset.target].value);
                  this.setState({ isUpdatingTargetValue: true });
                }}
              >
                {"Analyze Target Value"}
              </Button>
            </div>
          )}
        <div className={isConsumer ? styles.gHeaderLeftConsumer : styles.gHeaderLeft}>
          {isConsumer ? (
            <React.Fragment />
          ) : (
            <div className={styles.gHeaderTop}>
              {isNext !== true && (
                <div
                  className={styles.homeIcon}
                  onClick={() => {
                    updateType(VIEW_TYPE.DATASETS);
                    history.push("/");
                  }}
                >
                  <Button style={{ paddingLeft: "7px", paddingRight: "7px" }}>
                    <img src={HomeIcon} />
                  </Button>
                </div>
              )}
              {isNext !== true && (
                <div className={styles.datasetHeader}>
                  <div>
                    <div className={styles.boldItem}>
                      <div
                        title={dataset.label}
                        style={{
                          width: "350px",
                          textOverflow: "ellipsis",
                          whiteSpace: "noWrap",
                          overflow: "hidden"
                          // marginLeft: "-7px",
                        }}
                      >
                        <LineInput
                          isCleanEditable
                          isMediumBox
                          value={dataset && dataset.label ? dataset.label : "Dataset"}
                          onChange={(v) => (v !== dataset.label ? changeDatasetName(v) : "")}
                          ref={"datasetName"}
                          isLocked={!canEdit}
                        />
                      </div>
                    </div>
                    <div className={styles.subItem}>
                      {moment.utc(dataset.created).local().format("MMMM Do YYYY, h:mm:ss a")}
                    </div>
                  </div>
                  {this.renderBlueprintSelect()}
                </div>
              )}
            </div>
          )}
          {!isNext && (
            <div className={isConsumer ? styles.gHeaderBottomConsumer : styles.gHeaderBottom}>
              <FeedbackContainer id={id} isSmall hideTags />
            </div>
          )}
        </div>
        {isConsumer !== true && (
          <div className={styles.toggleHolder}>
            <Toggle
              checked={isAutoIgnore}
              icons={false}
              onChange={(e) => this.setState({ isAutoIgnore: !isAutoIgnore })}
            />
            <span className={isAutoIgnore ? styles.yPosHammer : styles.nPosHammer}>{isAutoIgnore ? "Yes" : "No"}</span>
            <span style={{ marginLeft: "5px" }}>
              {isExploring
                ? "Hide inert columns"
                : "Hide " + inertCount + " inert column" + (inertCount > 1 ? "s" : "")}
            </span>
          </div>
        )}
        {isConsumer !== true && (
          <div className={styles.actionButtons}>
            <ButtonGroup>
              <Button
                onClick={() => {
                  this.setState({ isLinkReport: false });
                  updateRightMode(GALLERY_RIGHT_MODE.LINEAGE);
                }}
                active={rightMode === GALLERY_RIGHT_MODE.LINEAGE}
              >
                <img src={LineageIcon} style={{ marginRight: "5px" }} />
                {"Lineage"}
              </Button>
            </ButtonGroup>
          </div>
        )}
      </div>
    );
  }

  getBlueprintMatchField(field) {
    const { matchedColumns } = this.props;

    const activeBlueprint = this.getActiveBlueprint();

    return field &&
      activeBlueprint &&
      matchedColumns &&
      matchedColumns[field.label] &&
      activeBlueprint.wizard.dataset &&
      activeBlueprint.wizard.dataset.fields &&
      activeBlueprint.wizard.dataset.fields[matchedColumns[field.label]]
      ? activeBlueprint.wizard.dataset.fields[matchedColumns[field.label]]
      : undefined;
  }

  renderField(field) {
    const {
      isNext,
      updateViewField,
      dataset,
      addExploreOutcome,
      isExploring,
      exploreOutcomes,
      aiReadyOutcomes,
      updateOutcomeSuccess,
      outcomeSuccess,
      isConsumer,
      isAdvanced,
      canEdit
    } = this.props;

    const retOutcomeSuccess =
      field.type !== "categorical" || !field.data || field.data.length === 0
        ? undefined
        : outcomeSuccess && outcomeSuccess[field.label]
          ? outcomeSuccess[field.label].value
          : (field.data.sort((a, b) => (a.value < b.value ? -1 : a.value > b.value ? 1 : 0))[0] || {}).value;

    const hasBeenExplored = exploreOutcomes && field && field.label && exploreOutcomes[field.label];

    const isAiReady = aiReadyOutcomes && field && field.label && aiReadyOutcomes.includes(field.label);

    const activeBlueprint = this.getActiveBlueprint();
    const matchedBlueprintField = this.getBlueprintMatchField(field);

    const activeMatchedColumns = this.getActiveMatchedColumns();

    const isOutcome = dataset && field && dataset.outcome === field.label;

    return (
      <div className={styles.descInput + " " + styles.nameCol}>
        <div className={styles.fFlex}>
          {field.type === "categorical" && !field.isNumeric ? (
            <img src={CategoryIcon} style={{ marginRight: "5px", width: "20px" }} title={"Categorical"} />
          ) : field.type === "date" ? (
            <img src={DateIcon} style={{ marginRight: "5px", width: "18px", marginTop: "-2px" }} title={"Date"} />
          ) : (
            <img src={NumberIcon} style={{ marginRight: "5px", marginLeft: "-2px", width: "20px" }} title={"Numeric"} />
          )}
          <div className={styles.bFlex}>
            <a title={field.label} onClick={() => updateViewField(field)}>
              {field.label}
            </a>
            {activeBlueprint && activeMatchedColumns && activeMatchedColumns[field.label] && (
              <span>
                <img src={BlueprintIcon} className={styles.bIcon} />
                {activeMatchedColumns[field.label]}
                {matchedBlueprintField && matchedBlueprintField.isSensitive && (
                  <span style={{ marginLeft: "5px", color: "#868595" }} title="Sensitive">
                    <FontAwesomeIcon icon={faEyeSlash} />
                  </span>
                )}
                {matchedBlueprintField && matchedBlueprintField.isIgnoreAnalysis && (
                  <span style={{ marginLeft: "5px", color: "#868595" }} title={field.label + " will not be explorable"}>
                    <FontAwesomeIcon icon={faBan} />
                  </span>
                )}
                {matchedBlueprintField && matchedBlueprintField.isActionable && (
                  <span style={{ marginLeft: "5px", color: "#868595" }} title="Actionable">
                    {"Actionable"}
                  </span>
                )}
              </span>
            )}
          </div>
        </div>
        {isAdvanced === true ? (
          <div className={styles.exploreWrapper + " " + (isOutcome ? styles.active : "")}>
            {isOutcome && (
              <div className={styles.bExploreIcon}>
                <FontAwesomeIcon icon={faCheck} className={styles.bIconPurple} style={{ marginLeft: "-11px" }} />
              </div>
            )}
          </div>
        ) : (
          <div className={styles.exploreWrapper + " " + (hasBeenExplored ? styles.active : "")}>
            {isExploring === field.label && isExploring !== undefined ? (
              <div className={styles.evalLoader}>
                <div>
                  <span style={{ marginRight: "3px" }}>{"Evaluating"}</span>
                  <span style={{ fontWeight: "bold" }}>{field.label}</span>
                  <span>{"..."}</span>
                </div>
                <LoadingIndicator style={{ margin: "0px" }} />
              </div>
            ) : isNext ? null : (
              canEdit &&
              isExploring === undefined &&
              field.type !== "date" && (
                <React.Fragment>
                  {field.type === "categorical" && (
                    <div className={styles.exploreSelect + " " + (hasBeenExplored ? styles.active : "")}>
                      <Select
                        options={
                          field && field.data
                            ? field.data.map((f) => ({
                                label: f.value,
                                value: f.value
                              }))
                            : []
                        }
                        menuPosition="fixed"
                        value={{
                          label: retOutcomeSuccess,
                          value: retOutcomeSuccess
                        }}
                        onChange={(val) => {
                          updateOutcomeSuccess({
                            ...outcomeSuccess,
                            [field.label]: val
                          });

                          // TODO: Bad refresh component
                          this.setState({ fixMe: !this.state.fixMe });
                        }}
                      />
                    </div>
                  )}
                  <OverlayTrigger
                    placement="right"
                    trigger={hasBeenExplored ? [] : ["hover"]}
                    rootClose
                    overlay={
                      <Popover id="popover-positioned-right">
                        <div className={styles.bPopover}>
                          {isConsumer
                            ? "Evaluates a column for key insights and checks its AI readiness"
                            : "Exploring evaluates a column for key insights and checks its AI readiness"}
                        </div>
                      </Popover>
                    }
                  >
                    <button
                      onClick={
                        hasBeenExplored
                          ? () => {}
                          : () => {
                              addExploreOutcome(field.label);
                            }
                      }
                      className={
                        styles.exploreButton +
                        " " +
                        (hasBeenExplored ? styles.active : "") +
                        " " +
                        (isConsumer && hasBeenExplored ? (isAiReady ? styles.green : styles.yellow) : "")
                      }
                    >
                      {isConsumer ? (
                        <div className={styles.bExploreIcon}>
                          <FontAwesomeIcon
                            icon={faCheck}
                            className={styles.bIconPurple}
                            style={hasBeenExplored ? { marginLeft: "-11px" } : {}}
                          />
                          {isConsumer && hasBeenExplored && !isAiReady ? (
                            <img
                              src={HourglassIcon}
                              className={styles.bIconWhite}
                              style={{ height: "13px", width: "13px" }}
                            />
                          ) : (
                            <FontAwesomeIcon icon={faCheck} className={styles.bIconWhite} />
                          )}
                        </div>
                      ) : (
                        <div className={styles.bExploreIcon}>
                          <img src={ExploreIcon} className={styles.bIconPurple} />
                          <img src={ExploreIconWhite} className={styles.bIconWhite} />
                        </div>
                      )}
                      <div
                        className={
                          (isConsumer ? styles.bExploreTextConsumer : styles.bExploreText) +
                          " " +
                          (hasBeenExplored ? (isConsumer ? styles.show : styles.hide) : "") +
                          " " +
                          (isConsumer && hasBeenExplored ? (isAiReady ? styles.green : styles.yellow) : "")
                        }
                      >
                        {isConsumer === true
                          ? hasBeenExplored
                            ? isAiReady
                              ? "AI Ready"
                              : "Need more Data"
                            : "Test For AI Readiness"
                          : "Explore"}
                      </div>
                    </button>
                  </OverlayTrigger>
                </React.Fragment>
              )
            )}
          </div>
        )}
      </div>
    );
  }

  renderDescription(field, index) {
    const { matchedColumns, descriptions, blueprintColumnDescriptions, updateColumnDescriptionDataset, canEdit } =
      this.props;
    const { openIndex } = this.state;

    const activeBlueprint = this.getActiveBlueprint();

    return (
      <React.Fragment>
        <div className={styles.descInput} value={index}>
          {(descriptions && descriptions[field.index]) || openIndex === index || !canEdit ? (
            <LineInput
              isBox
              isCleanEditable
              style={{
                height: "50px",
                justifyContent: "flex-start",
                width: "100%"
              }}
              isLocked={!canEdit}
              placeholder=" "
              defaultValue={descriptions && descriptions[field.index] ? descriptions[field.index] : undefined}
              onChange={(value) => {
                updateColumnDescriptionDataset(field.index, field.label, value);
                this.setState({ fixMe: !this.state.fixMe });
              }}
            />
          ) : (
            <a className={styles.dClick} onClick={() => this.setState({ openIndex: index })}>
              {"Add Description"}
            </a>
          )}
          {activeBlueprint &&
            matchedColumns &&
            matchedColumns[field.label] &&
            blueprintColumnDescriptions &&
            blueprintColumnDescriptions[matchedColumns[field.label]] && (
              <div className={styles.descSecond}>
                <img src={BlueprintIcon} className={styles.bIcon + " " + styles.isInline} />
                {blueprintColumnDescriptions[matchedColumns[field.label]]}
              </div>
            )}
        </div>
      </React.Fragment>
    );
  }

  renderDistribution(field) {
    const { dataset } = this.props;

    if (field.type === undefined) {
      return (
        <div className={styles.evalLoader}>
          <LoadingIndicator style={{ margin: "0px" }} />
        </div>
      );
    }

    return (
      <div className={styles.distHolder}>
        <div
          className={styles.distChart}
          onClick={() =>
            this.setState({
              viewChart: { field: field, type: "Distribution" }
            })
          }
        >
          <DistributionChart dataset={dataset} field={field} />
        </div>
      </div>
    );
  }

  renderTable() {
    const {
      dataset,
      viewField,
      createAI,
      matchedColumns,
      isBlueprintSaved,
      isConsumer,
      isNext,
      isAdvanced,
      highlightField,
      outcomeSuccess,
      updateOutcomeSuccess,
      exploreOutcomes,
      updateMatchedColumn,
      removeExploreOutcome,
      sortField,
      updateSortField,
      correlations,
      activeTab
    } = this.props;

    const { isAutoIgnore } = this.state;

    const chartStyle = {
      minWidth: "400px",
      maxWidth: "400px",
      paddingLeft: "0px",
      display: "flex",
      justifyContent: "center",
      overflow: "visible"
    };

    const dStyle = {
      minWidth: "400px",
      maxWidth: "400px",
      display: "flex",
      overflow: "visible"
    };

    const smallStyle = {
      flexGrow: 0.5,
      minWidth: "150px"
    };

    const advancedWidth = {
      minWidth: "calc(25% - 28px)",
      maxWidth: "calc(25% - 28px)",
      paddingLeft: "0px",
      display: "flex",
      justifyContent: "center",
      overflow: "visible"
    };

    const activeBlueprint = this.getActiveBlueprint();

    const inertCount = this.getInertCount();

    const problematicPredictors =
      correlations?.problematicPredictors?.length > 0 ? correlations.problematicPredictors : [];

    const evalColumns =
      isConsumer && isAdvanced !== true
        ? []
        : exploreOutcomes
          ? Object.keys(exploreOutcomes)
              .filter((o) => exploreOutcomes[o] === true)
              .filter((o) => isAdvanced !== true || (dataset && dataset.outcome === o))
              .map((o) => ({
                label: (
                  <div>
                    {dataset && dataset.fields && dataset.fields[o] && dataset.fields[o].type === "categorical"
                      ? outcomeSuccess && outcomeSuccess[o]
                        ? "% " + o + ": " + outcomeSuccess[o].value
                        : "% " + o + ": " + dataset.fields[o].data && dataset.fields[o].data?.length
                          ? dataset.fields[o].data.sort((a, b) =>
                              a.value < b.value ? -1 : a.value > b.value ? 1 : 0
                            )[0].value
                          : ""
                      : o}
                    {sortField && sortField.field === o && (
                      <span>
                        <span style={{ marginLeft: "5px" }}>
                          <FontAwesomeIcon icon={sortField.dir === "DESC" ? faChevronDown : faChevronUp} />
                        </span>
                      </span>
                    )}
                    <span className={styles.trashIcon}>
                      <Button
                        style={{ marginRight: "5px", padding: "8px" }}
                        onClick={(e) => {
                          e.stopPropagation();

                          this.setState({
                            scaled: {
                              ...this.state.scaled,
                              [o]: !this.state.scaled[o]
                            }
                          });
                        }}
                        active={this.state.scaled[o] === true}
                      >
                        <img src={ScaleIcon} style={{ height: "13px", width: "13px" }} />
                      </Button>
                      <Button
                        style={{ padding: "8px", color: "#868595" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          removeExploreOutcome(o);
                        }}
                      >
                        <FontAwesomeIcon icon={faEyeSlash} />
                      </Button>
                    </span>
                  </div>
                ),
                fieldLabel: o,
                style: isAdvanced ? advancedWidth : chartStyle,
                isEval: true,
                render: (field) => {
                  const retOutcomeSuccess =
                    (field.type === "numeric" && field.type === "date") || !field.data || field.data.length === 0
                      ? undefined
                      : outcomeSuccess && outcomeSuccess[field.label]
                        ? outcomeSuccess[field.label].value
                        : field.data.sort((a, b) => (a.value < b.value ? -1 : a.value > b.value ? 1 : 0))[0].value;

                  const numPredictors =
                    dataset && dataset.fields
                      ? Object.keys(dataset.fields).filter(
                          (f) =>
                            dataset.fields[f].leakage_info &&
                            dataset.fields[f].leakage_info[o] &&
                            dataset.fields[f].leakage_info[o]["Abs Correlation"] < 0.3 &&
                            dataset.fields[o]?.inclusionProbabilities?.find((prob) => prob?.keys?.every((k) => k === f))
                              ?.value > 0.5
                        ).length
                      : 1;

                  return field && o && field.label === o ? (
                    <div>
                      {field.type === "categorical" && this.state.isCreatingAI === undefined && isAdvanced !== true && (
                        <div style={{ marginBottom: "5px" }}>
                          <Select
                            options={
                              field && field.data
                                ? field.data.map((f) => ({
                                    label: f.value,
                                    value: f.value
                                  }))
                                : []
                            }
                            value={{
                              label: retOutcomeSuccess,
                              value: retOutcomeSuccess
                            }}
                            onChange={(val) => {
                              updateOutcomeSuccess({
                                ...outcomeSuccess,
                                [field.label]: val
                              });

                              // TODO: Bad refresh component
                              this.setState({ fixMe: !this.state.fixMe });
                            }}
                          />
                        </div>
                      )}
                      {this.state.isCreatingAI === field.label ? (
                        <div className={styles.createBox}>
                          <div>{"Creating Frontier..."}</div>
                          <LoadingIndicator style={{ margin: "0px" }} />
                        </div>
                      ) : this.state.isCreatingAI !== undefined ? (
                        <div />
                      ) : (
                        <Button
                          type="purple"
                          onClick={
                            isAdvanced
                              ? () => {}
                              : isEnabled("edg")
                                ? () => this.setState({ isBuyAible: true })
                                : () => {
                                    this.setState({ isCreatingAI: field.label });
                                    createAI(
                                      field.label,
                                      retOutcomeSuccess
                                        ? [
                                            {
                                              label: retOutcomeSuccess,
                                              value: retOutcomeSuccess,
                                              count: 5000
                                            }
                                          ]
                                        : undefined
                                    );
                                  }
                          }
                          style={{
                            background: "#7E69D7",
                            borderColor: "#7E69D7"
                          }}
                        >
                          {isAdvanced ? (
                            <div className={styles.cButton}>
                              <div className={styles.cInner}>
                                <div>{"Your selected outcome"}</div>
                              </div>
                            </div>
                          ) : (
                            <div className={styles.cButton}>
                              {numPredictors < 4 ? (
                                <FontAwesomeIcon
                                  icon={faExclamationTriangle}
                                  style={{ width: "25px", height: "25px" }}
                                />
                              ) : (
                                <img src={AibleIcon} className={styles.aibleIcon} />
                              )}
                              <div className={styles.cInner}>
                                <div>{"Create AI with Aible"}</div>
                                <div>
                                  {numPredictors === 0
                                    ? "No Predictors"
                                    : numPredictors === 1
                                      ? "Only 1 Predictor"
                                      : (numPredictors < 4 ? "Only " + numPredictors : numPredictors) + " Predictors"}
                                </div>
                              </div>
                            </div>
                          )}
                        </Button>
                      )}
                    </div>
                  ) : (
                    <div
                      className={styles.outcomeHolder}
                      onClick={() =>
                        this.setState({
                          viewChart: {
                            field: field,
                            outcome: o,
                            type: "Outcome"
                          }
                        })
                      }
                    >
                      <OutcomeChart
                        isSmall
                        dataset={dataset}
                        field={field}
                        outcome={o}
                        outcomeSuccess={outcomeSuccess && o && outcomeSuccess[o] ? outcomeSuccess[o].value : undefined}
                        showCorrelation
                        hideChart={isAdvanced !== true && isConsumer}
                        isScaled={this.state.scaled[o]}
                      />
                    </div>
                  );
                }
              }))
          : [];

    const isHideBlueprint = activeBlueprint === undefined || isBlueprintSaved === true;

    const tableColumns = [
      {
        label: "Name",
        style: isAdvanced
          ? advancedWidth
          : isNext
            ? { minWidth: "40%", maxWidth: "40%" }
            : isConsumer
              ? { minWidth: "40%", maxWidth: "40%" }
              : smallStyle,
        render: (field) => this.renderField(field)
      },
      {
        label: "Blueprint Field",
        style: dStyle,
        isHide: isHideBlueprint,
        render: (field) => {
          const mField = matchedColumns && matchedColumns[field.label] ? matchedColumns[field.label] : undefined;

          return (
            <div style={{ width: "90%" }} key={mField}>
              <Select
                options={
                  activeBlueprint &&
                  activeBlueprint.wizard &&
                  activeBlueprint.wizard.dataset &&
                  activeBlueprint.wizard.dataset.fields
                    ? Object.keys(activeBlueprint.wizard.dataset.fields).map((f) => ({ label: f, value: f }))
                    : []
                }
                defaultValue={
                  mField
                    ? {
                        label: mField,
                        value: mField
                      }
                    : undefined
                }
                isClearable
                placeholder="Match Field"
                onChange={(val) => updateMatchedColumn(field.label, val ? val.value : undefined)}
              />
            </div>
          );
        }
      },
      {
        label: "Description",
        isHide: isHideBlueprint === true,
        style: smallStyle,
        render: (field, index) => this.renderDescription(field, index)
      },
      {
        label: "Distribution",
        style: isAdvanced
          ? advancedWidth
          : isNext
            ? { minWidth: "45%", maxWidth: "45%" }
            : isConsumer
              ? { minWidth: "45%", maxWidth: "45%" }
              : chartStyle,
        render: (field) => this.renderDistribution(field)
      },
      {
        label: "Description",
        isHide: isHideBlueprint === false || (isConsumer && isAdvanced !== true),
        style: isAdvanced ? { ...advancedWidth, paddingLeft: "10px" } : smallStyle,
        render: (field, index) => this.renderDescription(field, index)
      },
      {
        label: "Data Quality",
        style: {
          minWidth: isNext && activeTab !== "DETAIL" ? "15%" : "110px",
          maxWidth: isNext && activeTab !== "DETAIL" ? "15%" : "110px",
          borderRight: isNext ? "none" : undefined,
          overflow: isNext ? "visible" : undefined
        },
        render: (field) => {
          const warnings = field?.warnings ? field.warnings.slice() : [];
          const highCardinalityWarning = problematicPredictors.find((predictor) => predictor.label === field.label);
          if (highCardinalityWarning) {
            highCardinalityWarning.warningMessage = `Column ${highCardinalityWarning.label} is highly correlated with the target variable.`;
            warnings.push(highCardinalityWarning);
          }
          return (
            <div className={styles.quality}>
              {warnings.length > 0 ? (
                <OverlayTrigger
                  placement={"top"}
                  trigger={["hover", "click"]}
                  rootClose
                  overlay={
                    <Popover id={"popover-positioned-top"} title={"Warnings"}>
                      {warnings.map((w, i) => {
                        return <div key={i}>{w?.warningMessage ? w.warningMessage : parseWarningForEDG(w)}</div>;
                      })}
                    </Popover>
                  }
                >
                  <span>
                    <span className={styles.warnIcon}>
                      <img src={WarnIcon} />
                    </span>
                    {warnings.length}
                  </span>
                </OverlayTrigger>
              ) : (
                <span>
                  <img src={CheckIcon} style={{ marginLeft: "3px", marginRight: "8px" }} />
                </span>
              )}
            </div>
          );
        }
      }
    ].filter((a) => a.isHide !== true);

    const tableWidth = (isHideBlueprint ? 1380 : 1780) + evalColumns.length * 400 + "px";

    return (
      <div
        id="#mainTable"
        className={
          isNext
            ? styles.gTableNext
            : isAdvanced
              ? styles.gTableAdvanced
              : isConsumer
                ? styles.gTableConsumer
                : styles.gTable
        }
        style={
          tableColumns && isConsumer !== true
            ? {
                minWidth: tableWidth
              }
            : {}
        }
      >
        <div
          className={isConsumer ? styles.gTableHeaderConsumer : styles.gTableHeader}
          style={
            isConsumer
              ? {}
              : document.getElementById("#mainTable") && document.getElementById("#mainTable").clientWidth
                ? { minWidth: document.getElementById("#mainTable").clientWidth }
                : {
                    minWidth: tableWidth
                  }
          }
        >
          {tableColumns.map((c, i) => (
            <div
              className={styles.gTableCol}
              style={{ ...c.style, cursor: c.isEval ? "pointer" : "initial" }}
              key={i}
              onClick={
                c.isEval
                  ? () =>
                      updateSortField({
                        field: c.fieldLabel,
                        dir: sortField && sortField.dir === "DESC" ? "ASC" : "DESC"
                      })
                  : () => {}
              }
            >
              {c.label}
            </div>
          ))}
        </div>
        <div className={styles.gTableBody}>
          {sortField !== undefined &&
          sortField.field !== undefined &&
          dataset &&
          dataset.fields &&
          dataset.fields[sortField.field] ? (
            <div className={isConsumer ? styles.gTableRowConsumer : styles.gTableRow}>
              {tableColumns.map((c, j, cArr) => (
                <div className={styles.gTableCol} style={c.style} key={j}>
                  {c.render(dataset.fields[sortField.field], -1 * cArr.length + j)}
                </div>
              ))}
            </div>
          ) : (
            <div />
          )}
          {dataset && dataset.fields ? (
            Object.keys(dataset.fields)
              .filter((f) => sortField === undefined || sortField.field === undefined || sortField.field !== f)
              .filter((f) => {
                const matchedBlueprintField = this.getBlueprintMatchField(dataset.fields[f]);

                return (
                  isHideBlueprint !== true ||
                  matchedBlueprintField === undefined ||
                  matchedBlueprintField.isIgnoreAnalysis !== true
                );
              })
              .sort((a, b) => {
                if (isConsumer) {
                  if (exploreOutcomes[a] && !exploreOutcomes[b]) {
                    return -1;
                  } else if (!exploreOutcomes[a] && exploreOutcomes[b]) {
                    return 1;
                  } else {
                    return a < b ? -1 : 1;
                  }
                }

                if (sortField === undefined || sortField.field === undefined) {
                  return 0;
                }

                const firstProb =
                  dataset.fields[sortField.field].inclusionProbabilities?.find((prob) =>
                    prob?.keys?.every((k) => k === a)
                  )?.value ?? 0;

                const secondProb =
                  dataset.fields[sortField.field].inclusionProbabilities?.find((prob) =>
                    prob?.keys?.every((k) => k === b)
                  )?.value ?? 0;

                return firstProb < secondProb
                  ? sortField && sortField.dir === "DESC"
                    ? 1
                    : -1
                  : firstProb > secondProb
                    ? sortField && sortField.dir === "DESC"
                      ? -1
                      : 1
                    : 0;
              })
              .map((f, i, data111) => {
                const matchedBlueprintField = this.getBlueprintMatchField(dataset.fields[f]);

                const isRemoved = matchedBlueprintField && matchedBlueprintField.isIgnoreAnalysis === true;

                return (
                  <div
                    className={
                      (isConsumer ? styles.gTableRowConsumer : styles.gTableRow) +
                      " " +
                      ((viewField && viewField.label === f) || (highlightField && highlightField === f)
                        ? styles.gTableRowSelected
                        : "") +
                      " " +
                      (matchedColumns && matchedColumns[f] !== undefined && isBlueprintSaved !== true
                        ? styles.gTableRowMatched
                        : "") +
                      " " +
                      (isAutoIgnore &&
                      exploreOutcomes &&
                      exploreOutcomes[f] !== true &&
                      Object.keys(exploreOutcomes).filter((k) => exploreOutcomes[k] === true).length > 0 &&
                      dataset.fields[dataset.outcome].inclusionProbabilities &&
                      Object.keys(exploreOutcomes)
                        .filter((k) => exploreOutcomes[k] === true)
                        .reduce((a, b) => {
                          const currProb = dataset.fields[b].inclusionProbabilities?.find((prob) =>
                            prob?.keys?.every((k) => k === f)
                          )?.value;
                          return a && (currProb === undefined || currProb < 0.5);
                        }, true) === true
                        ? styles.gTableRowHide
                        : "") +
                      " " +
                      (isRemoved ? styles.gTableRowRemoved : "")
                    }
                    key={i}
                  >
                    {tableColumns.map((c, j) => (
                      <div className={styles.gTableCol} style={c.style} key={j}>
                        {c.render(dataset.fields[f], i)}
                      </div>
                    ))}
                  </div>
                );
              })
          ) : (
            <div />
          )}
        </div>
        {isAutoIgnore && (
          <div className={styles.inertFooter} onClick={() => this.setState({ isAutoIgnore: false })}>
            <a>{inertCount + " inert fields hidden"}</a>
          </div>
        )}
      </div>
    );
  }

  renderLineageItem(icon, label, subItem, date, details) {
    return (
      <div className={styles.lineageItem}>
        <div className={styles.lineageIcon}>
          <img src={icon} />
        </div>
        <div className={styles.lineageRight}>
          <div className={styles.normalBold}>{label}</div>
          {details ? <div className={styles.sItem}>{details}</div> : ""}
          <div className={styles.sItem}>{subItem}</div>
          <div className={styles.subItem}>{date}</div>
        </div>
      </div>
    );
  }

  renderReports() {
    const { id, linkedReports, history } = this.props;
    return (
      <Accordion
        header={
          <div className={styles.reportsAccordionHeader}>
            <Icon src={reportsIcon} />
            <span>{(linkedReports && linkedReports.length ? linkedReports.length : 0) + " Reports"}</span>
          </div>
        }
        show={linkedReports && linkedReports.length ? undefined : false}
        bodyClass={styles.reportsAccordionBody}
      >
        {linkedReports &&
          linkedReports.map((r, i) => {
            const isLinkReport = !!(r.metadata && r.metadata.linkedData);
            return (
              <div className={styles.reportsItemWrapper} key={i}>
                <Icon type={isLinkReport ? "link" : "chart"} />
                <div className={styles.reportsContent}>
                  <a
                    className={styles.reportsTitle}
                    onClick={() => {
                      return history.push("/report/" + r.id);
                    }}
                  >
                    {r.name || r.label}
                  </a>
                  {isLinkReport ? (
                    <div className={styles.reportsInfo}>
                      {/* <Icon type={"link"} size={12} /> */}
                      <span style={{ marginLeft: "0px" }}>
                        {r.metadata.linkedData.dashboardLoc
                          ? r.metadata.linkedData.dashboardLoc.label + " Report"
                          : "Linked Report"}
                      </span>
                    </div>
                  ) : (
                    <div className={styles.reportsInfo}>
                      {r.created_by && r.created_by.fullname !== undefined ? r.created_by.fullname : r.created_by}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </Accordion>
    );
  }

  renderLinkReport() {
    const { activeTab, dataset, exploreOutcomes, createLinkedReport, isCreatingLinkedReport, outcomeSuccess } =
      this.props;

    const dashboardOptions = [
      { value: "MicroStrategy", label: "MicroStrategy" },
      { value: "Power BI", label: "Power BI" },
      { value: "Qlik", label: "Qlik" },
      { value: "Tableau", label: "Tableau" },
      { value: "Other", label: "Other" }
    ];

    const fieldOptions =
      dataset && dataset.fields ? Object.keys(dataset.fields).map((f) => ({ label: f, value: f })) : [];

    const customStyles = {
      container: (base, state) => {
        return {
          ...base,
          zIndex: state.isFocused ? "999" : "1"
        };
      }
    };

    const yDefault = exploreOutcomes
      ? Object.keys(exploreOutcomes)
          .filter((o) => exploreOutcomes[o] === true)
          .map((o) => {
            const oField = dataset && dataset.fields ? dataset.fields[o] : undefined;

            const retOutcomeSuccess =
              oField === undefined || !oField.data || oField.data.length === 0
                ? undefined
                : oField.type !== "categorical"
                  ? undefined
                  : outcomeSuccess && outcomeSuccess[oField.label]
                    ? outcomeSuccess[oField.label].value
                    : (oField.data.sort((a, b) => (a.value < b.value ? -1 : a.value > b.value ? 1 : 0))[0] || {}).value;

            return { value: o, label: o, success: retOutcomeSuccess };
          })
      : undefined;

    const totalInclude = {};

    dataset &&
      dataset.fields &&
      Object.keys(dataset.fields).forEach((f) => {
        if (dataset.fields[f] && dataset.fields[f].inclusionProbabilities) {
          dataset.fields[f].inclusionProbabilities.forEach((p) => {
            totalInclude[f] = (totalInclude[f] ?? 0) + (p?.value ?? 0);
          });
        }
      });

    const dInclude = Object.keys(totalInclude)
      .filter((f) => exploreOutcomes && exploreOutcomes[f] !== true)
      .map((f) => ({ label: f, score: totalInclude[f], value: f }))
      .sort((a, b) => (a.score < b.score ? 1 : a.score > b.score ? -1 : 0))
      .filter((f, i) => i < 2);

    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{"Data Lineage"}</div>
        <div className={styles.rightContent}>
          <div className={styles.smallBold}>{"Link a Report"}</div>
          <div>
            {"Document what external applications (like Tableau or Power BI)" +
              " are accessing the information in this dataset"}
          </div>
          <div style={{ marginTop: "20px" }}>
            <div>{"Dashboard Location"}</div>
            <Select
              options={dashboardOptions}
              placeholder={"Select External Dashboard"}
              styles={customStyles}
              ref={"dashboardLoc"}
            />
          </div>
          <LineInput
            isMediumBox
            topLabel="Link to Source"
            placeholder={"Enter Link to Dashboard"}
            style={{ marginTop: "30px" }}
            ref={"sourceURL"}
          />
          <LineInput
            isMediumBox
            topLabel="Name"
            defaultValue={"New Linked Report"}
            style={{ marginTop: "30px" }}
            ref={"linkReportName"}
          />
          <LineInput
            isMediumBox
            topLabel="Description"
            defaultValue={dataset ? dataset.label : undefined}
            style={{ marginTop: "30px" }}
            ref={"linkReportDesc"}
          />
          <div className={styles.smallBold} style={{ marginTop: "30px" }}>
            {"Metrics and Categories Graphed"}
          </div>
          <div>
            <div>{"Metrics (y-axis)"}</div>
            <Select
              options={fieldOptions}
              defaultValue={yDefault}
              placeholder="Metrics"
              isMulti
              menuPlacement="top"
              styles={customStyles}
              ref={"yColumns"}
            />
          </div>
          <div style={{ marginTop: "20px" }}>
            <div>{"Category (x-axis)"}</div>
            <Select
              options={fieldOptions}
              defaultValue={dInclude}
              placeholder="Category"
              isMulti
              menuPlacement="top"
              styles={customStyles}
              ref={"xColumns"}
            />
          </div>
        </div>
        <div className={styles.rightFooterEdit}>
          <Button onClick={() => this.setState({ isLinkReport: false })}>{"Back"}</Button>
          {isCreatingLinkedReport === true ? (
            <LoadingIndicator style={{ margin: "0px" }} />
          ) : (
            <Button
              type="primary"
              onClick={() => {
                const linkReportObj = {
                  dashboardLoc: this.getValueFromSelectRef("dashboardLoc"),
                  yColumns: this.getValueFromSelectRef("yColumns"),
                  xColumns: this.getValueFromSelectRef("xColumns"),
                  name: this.getValueFromLineInputRef("linkReportName"),
                  sourceURL: this.getValueFromLineInputRef("sourceURL"),
                  description: this.getValueFromLineInputRef("linkReportDesc"),
                  datasetId: dataset ? dataset.id : undefined
                };

                createLinkedReport(linkReportObj);
              }}
            >
              {"Save"}
            </Button>
          )}
        </div>
      </div>
    );
  }

  getValueFromLineInputRef(ref) {
    return this.refs[ref] && this.refs[ref].state && this.refs[ref].state.tempVal
      ? this.refs[ref].state.tempVal
      : undefined;
  }

  getValueFromSelectRef(ref) {
    return this.refs[ref] && this.refs[ref].state && this.refs[ref].state.value
      ? this.refs[ref].state.value
      : undefined;
  }

  renderRightLineage() {
    const {
      id,
      dataset,
      combineDataset,
      updateRightMode,
      matchedColumns,
      transform,
      filters,
      lookupKeys,
      dataSourceDetails,
      linkedSchemaChanges,
      linkedSchenaMonitor,
      isLinkedDataset
    } = this.props;

    const { isLinkReport } = this.state;

    const dataSourceImage = (dataSourceDetails && dataSourceDetails.image) || CreateIcon;
    const dataSourceTable = dataset && dataset.source && dataset.source.content && dataset.source.content.table;
    const dataSourceLabel = dataSourceDetails ? dataSourceDetails.label : "CSV";

    const activeBlueprint = this.getActiveBlueprint();

    return isLinkReport ? (
      this.renderLinkReport()
    ) : (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{"Data Lineage"}</div>
        <div className={styles.rightContent}>
          <ExportJSONContainer id={dataset.id}>
            {isLinkedDataset ? "Access Credentials" : "Access Dataset"}
          </ExportJSONContainer>
          <Button style={{ marginLeft: "20px" }} onClick={() => this.setState({ isLinkReport: true })}>
            {"Link Report"}
          </Button>
          {/* <Select options={filterOptions} placeholder="Filter View" /> */}
          <div className={styles.reportsAccordion}>{this.renderReports()}</div>
          <div className={styles.lineageList}>
            {this.renderLineageItem(
              dataSourceImage,
              "Dataset Created From " + dataSourceLabel,
              dataset.created_by.fullname,
              moment.utc(dataset.created).local().format("MMMM Do YYYY, h:mm:ss a"),
              dataSourceTable
            )}
            {this.renderLineageItem(
              AIReadyIcon,
              "Exploratory Analysis Conducted",
              dataset.outcome,
              moment.utc(dataset.updated_date).local().format("MMMM Do YYYY, h:mm:ss a")
            )}
            {combineDataset &&
              this.renderLineageItem(
                JoinIcon,
                "Combine Dataset",
                combineDataset.label,
                <a onClick={() => updateRightMode(GALLERY_RIGHT_MODE.COMBINE)}>
                  {(lookupKeys === undefined ? "0" : Object.keys(lookupKeys).length) + " lookup fields"}
                </a>
              )}
            {activeBlueprint &&
              this.renderLineageItem(
                JoinIcon,
                "Mapped Blueprint",
                activeBlueprint && activeBlueprint.wizard && activeBlueprint.wizard.setup
                  ? activeBlueprint.wizard.setup.label
                  : "Blueprint",
                <div>
                  {matchedColumns ? (
                    <div className={styles.subItem}>{Object.keys(matchedColumns).length + " mapped columns"}</div>
                  ) : (
                    <a onClick={() => updateRightMode(GALLERY_RIGHT_MODE.BLUEPRINT)}>{"View Mapped Blueprint"}</a>
                  )}
                </div>
              )}
            {linkedSchemaChanges &&
              this.renderLineageItem(
                dataSourceImage,
                "Schema Changed" + (linkedSchenaMonitor ? " at " + linkedSchenaMonitor.name : ""),
                <OverlayTrigger
                  placement="top"
                  trigger={["click"]}
                  rootClose
                  overlay={
                    <Popover id="popover-positioned-top" title={"Database Changes"}>
                      <div className={styles.changesOverlay}>
                        <DatasetSchemaChangesContainer id={id} />
                      </div>
                    </Popover>
                  }
                >
                  <a className={styles.changesTrigger}>
                    {(linkedSchemaChanges.table ? linkedSchemaChanges.table.length : 0) +
                      (linkedSchemaChanges.columns ? linkedSchemaChanges.columns.length : 0) +
                      " change" +
                      ((linkedSchemaChanges.table ? linkedSchemaChanges.table.length : 0) +
                        (linkedSchemaChanges.columns ? linkedSchemaChanges.columns.length : 0) !==
                      1
                        ? "s"
                        : "")}
                  </a>
                </OverlayTrigger>,
                linkedSchenaMonitor
                  ? moment.utc(linkedSchenaMonitor.updated_date).local().format("MMMM Do YYYY, h:mm:ss a")
                  : "",
                dataSourceTable
              )}
            {transform &&
              Object.keys(transform)
                .filter((t) => transform[t].saved === true)
                .map((t, i) => (
                  <div index={i}>
                    {this.renderLineageItem(
                      CreateIcon,
                      "Add Derived Variable",
                      transform[t].fieldOne.label +
                        " " +
                        (transform[t].operation ? transform[t].operation.label : transform[t].operation) +
                        " " +
                        transform[t].fieldTwo.label,
                      <a onClick={() => updateRightMode(GALLERY_RIGHT_MODE.DERIVED)}>{"View Derived Variables"}</a>
                    )}
                  </div>
                ))}
            {filters &&
              Object.keys(filters)
                .filter((t) => filters[t].state === "DONE")
                .map((t) =>
                  this.renderLineageItem(
                    FilterIcon,
                    "Filter Variable",
                    filters[t].first + " " + filters[t].operation + " " + filters[t].second,
                    <a onClick={() => updateRightMode(GALLERY_RIGHT_MODE.FILTER)}>{"View Filter"}</a>
                  )
                )}
          </div>
        </div>
        <div className={styles.rightFooter}></div>
      </div>
    );
  }

  renderRightExplore() {
    const { dataset } = this.props;

    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{"Metadata"}</div>
        <div className={styles.rightContent}>
          <div className={styles.metaHolder}>
            <div style={{ marginTop: "10px" }}>
              <div className={styles.smallBold}>{"Label"}</div>
              <div className={styles.subitem}>{dataset.label}</div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <div className={styles.smallBold}>{"Description"}</div>
              <div className={styles.subitem}>{"Description Placeholder"}</div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <div className={styles.smallBold}>{"Created"}</div>
              <div className={styles.subItem}>
                {moment.utc(dataset.created).local().format("MMMM Do YYYY, h:mm:ss a")}
              </div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <div className={styles.smallBold}>{"Columns"}</div>
              <div className={styles.subItem}>{Object.keys(dataset.fields).length}</div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <div className={styles.smallBold}>{"Rows"}</div>
              <div className={styles.subItem}>{dataset.rowCount}</div>
            </div>
          </div>
        </div>
        <div className={styles.rightFooter}></div>
      </div>
    );
  }

  renderRightCombine() {
    const {
      datasets,
      dataset,
      lookupKeys,
      isSaving,
      joinType,
      updateRightMode,
      updateCombineDataset,
      updateLookupKey,
      updateJoinType,
      combineDataset,
      saveChanges
    } = this.props;

    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{"Combine Dataset"}</div>
        <div className={styles.rightContent}>
          <div className={styles.normalBold}>{"Select a Dataset"}</div>
          <Select
            options={datasets && datasets.map((d) => ({ label: d.name, value: d.id, dataset: d }))}
            defaultValue={combineDataset ? { label: combineDataset.name, value: combineDataset.value } : undefined}
            onChange={(val) => updateCombineDataset(val.dataset)}
          />
          {combineDataset && (
            <div>
              <div className={styles.normalBold} style={{ marginTop: "40px" }}>
                {"Lookup Keys"}
              </div>
              <div className={styles.lookupContent}>
                {lookupKeys &&
                  Object.keys(lookupKeys)
                    .filter((lKey) => lookupKeys[lKey].state !== "DELETE")
                    .map((lKey, i) => (
                      <div className={styles.lookup} key={i}>
                        <div
                          style={{
                            marginRight: "10px",
                            maxWidth: "32%",
                            minWidth: "32%"
                          }}
                        >
                          <div className={styles.subItem}>{dataset.name}</div>
                          <Select
                            options={Object.keys(dataset.fields).map((f) => ({
                              label: f,
                              value: f
                            }))}
                            defaultValue={{
                              label: lookupKeys[lKey].first,
                              value: lookupKeys[lKey].first
                            }}
                            ref={lookupKeys[lKey].state === "EDIT" ? "lookupFieldOneEdit" : ""}
                            placeholder="Lookup Field"
                            isDisabled={lookupKeys[lKey].state !== "EDIT"}
                          />
                        </div>
                        <div
                          style={{
                            marginLeft: "10px",
                            maxWidth: "32%",
                            minWidth: "32%",
                            marginRight: "20px"
                          }}
                        >
                          <div className={styles.subItem}>{combineDataset.name}</div>
                          <Select
                            options={Object.keys(combineDataset.fields).map((f) => ({
                              label: f,
                              value: f
                            }))}
                            defaultValue={{
                              label: lookupKeys[lKey].second,
                              value: lookupKeys[lKey].second
                            }}
                            ref={lookupKeys[lKey].state === "EDIT" ? "lookupFieldTwoEdit" : ""}
                            placeholder="Matching Field"
                            isDisabled={lookupKeys[lKey].state !== "EDIT"}
                          />
                        </div>
                        {lookupKeys[lKey].state !== "EDIT" ? (
                          <ButtonGroup>
                            <Button
                              onClick={() =>
                                updateLookupKey(lKey, {
                                  ...lookupKeys[lKey],
                                  state: "EDIT"
                                })
                              }
                            >
                              {"Edit"}
                            </Button>
                            <Button
                              onClick={() =>
                                updateLookupKey(lKey, {
                                  ...lookupKeys[lKey],
                                  state: "DELETE"
                                })
                              }
                            >
                              {"Delete"}
                            </Button>
                          </ButtonGroup>
                        ) : (
                          <ButtonGroup>
                            <Button
                              onClick={() => {
                                if (
                                  this.refs.lookupFieldOne &&
                                  this.refs.lookupFieldOne.state &&
                                  this.refs.lookupFieldOne.state.value &&
                                  this.refs.lookupFieldTwo &&
                                  this.refs.lookupFieldTwo.state &&
                                  this.refs.lookupFieldTwo.state.value
                                ) {
                                  updateLookupKey(lKey, {
                                    ...lookupKeys[lKey],
                                    first: this.refs.lookupFieldOneEdit.state.value.value,
                                    second: this.refs.lookupFieldTwoEdit.state.value.value,
                                    state: "DONE"
                                  });
                                }
                              }}
                            >
                              {"Save"}
                            </Button>
                            <Button
                              onClick={() =>
                                updateLookupKey(lKey, {
                                  ...lookupKeys[lKey],
                                  state: "DONE"
                                })
                              }
                            >
                              {"Cancel"}
                            </Button>
                          </ButtonGroup>
                        )}
                      </div>
                    ))}
                <div className={styles.lookup}>
                  <div style={{ marginRight: "10px" }}>
                    <div className={styles.subItem}>{dataset.name}</div>
                    <Select
                      options={Object.keys(dataset.fields).map((f) => ({
                        label: f,
                        value: f
                      }))}
                      ref="lookupFieldOne"
                      placeholder="Lookup Field"
                    />
                  </div>
                  <div style={{ marginLeft: "10px" }}>
                    <div className={styles.subItem}>{combineDataset.name}</div>
                    <Select
                      options={Object.keys(combineDataset.fields).map((f) => ({
                        label: f,
                        value: f
                      }))}
                      ref="lookupFieldTwo"
                      placeholder="Matching Field"
                    />
                  </div>
                </div>
              </div>
              <div style={{ width: "100%", textAlign: "right", marginTop: "10px" }}>
                <Button
                  onClick={() => {
                    if (
                      this.refs.lookupFieldOne &&
                      this.refs.lookupFieldOne.state &&
                      this.refs.lookupFieldOne.state.value &&
                      this.refs.lookupFieldTwo &&
                      this.refs.lookupFieldTwo.state &&
                      this.refs.lookupFieldTwo.state.value
                    ) {
                      const currentKeyLength = lookupKeys ? Object.keys(lookupKeys).length : 0;

                      updateLookupKey(currentKeyLength, {
                        index: currentKeyLength,
                        state: "DONE",
                        first: this.refs.lookupFieldOne.state.value.value,
                        second: this.refs.lookupFieldTwo.state.value.value
                      });
                    }
                  }}
                >
                  {"Add Key"}
                </Button>
              </div>
              <div className={styles.normalBold} style={{ marginTop: "40px" }}>
                {"Join Type"}
              </div>
              <ButtonGroup>
                <Button onClick={() => updateJoinType(JOIN_TYPES.LOOKUP)} active={joinType === JOIN_TYPES.LOOKUP}>
                  {"Lookup"}
                </Button>
                <Button onClick={() => updateJoinType(JOIN_TYPES.LEFT_JOIN)} active={joinType === JOIN_TYPES.LEFT_JOIN}>
                  {"Left Join"}
                </Button>
                <Button
                  onClick={() => updateJoinType(JOIN_TYPES.RIGHT_JOIN)}
                  active={joinType === JOIN_TYPES.RIGHT_JOIN}
                >
                  {"Right Join"}
                </Button>
                <Button
                  onClick={() => updateJoinType(JOIN_TYPES.INNER_JOIN)}
                  active={joinType === JOIN_TYPES.INNER_JOIN}
                >
                  {"Inner Join"}
                </Button>
                <Button
                  onClick={() => updateJoinType(JOIN_TYPES.FULL_OUTER_JOIN)}
                  active={joinType === JOIN_TYPES.FULL_OUTER_JOIN}
                >
                  {"Full Outer Join"}
                </Button>
              </ButtonGroup>
              <div className={styles.normalBold} style={{ marginTop: "40px" }}>
                {"Summary"}
              </div>
              {dataset && (
                <div className={styles.subItem}>
                  <div>{"Input Dataset Rows: " + dataset.rowCount}</div>
                  <div>{"Input Dataset Cols: " + Object.keys(dataset.fields).length}</div>
                </div>
              )}
              {combineDataset && (
                <div className={styles.subItem}>
                  <div>{"Combine Dataset Rows: " + combineDataset.rowCount}</div>
                  <div>{"Combine Dataset Cols: " + Object.keys(combineDataset.fields).length}</div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className={styles.rightFooterEdit}>
          <Button onClick={() => updateRightMode(GALLERY_RIGHT_MODE.EDIT)}>{"Back"}</Button>
          {isSaving ? (
            <LoadingIndicator style={{ margin: "0px" }} />
          ) : (
            <Button type="primary" onClick={() => saveChanges()}>
              {"Save Changes"}
            </Button>
          )}
        </div>
      </div>
    );
  }

  renderRightAppend() {
    const { dataset, datasets, updateRightMode, isSaving, saveChanges, updateAppendDataset, appendDataset } =
      this.props;

    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{"Append Dataset"}</div>
        <div className={styles.rightContent}>
          <div className={styles.normalBold}>{"Select a Dataset"}</div>
          <Select
            options={datasets && datasets.map((d) => ({ label: d.name, value: d.id, dataset: d }))}
            onChange={(val) => updateAppendDataset(val.dataset)}
          />
          {appendDataset && (
            <div>
              <div className={styles.normalBold} style={{ marginTop: "40px" }}>
                {"Lookup Keys"}
              </div>
              <div className={styles.lookup}>
                <div style={{ marginRight: "10px" }}>
                  <div className={styles.subItem}>{dataset.name}</div>
                  <Select options={[]} placeholder="Lookup Field" />
                </div>
                <div style={{ marginLeft: "10px" }}>
                  <div className={styles.subItem}>{appendDataset.name}</div>
                  <Select options={[]} placeholder="Matching Field" />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={styles.rightFooterEdit}>
          <Button onClick={() => updateRightMode(GALLERY_RIGHT_MODE.EDIT)}>{"Back"}</Button>
          {isSaving ? (
            <LoadingIndicator style={{ margin: "0px" }} />
          ) : (
            <Button type="primary" onClick={() => saveChanges()}>
              {"Save Changes"}
            </Button>
          )}
        </div>
      </div>
    );
  }

  renderRightFilter() {
    const { dataset, filters, isSaving, updateRightMode, updateFilter, saveChanges } = this.props;

    const operations = [
      { label: "Does not equal", value: "Does not equal" },
      { label: "Equals", value: "Equals" }
    ];

    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{"Filter Data"}</div>
        <div className={styles.rightContent}>
          <div>
            <div className={styles.lookupContent}>
              {filters &&
                Object.keys(filters)
                  .filter((lKey) => filters[lKey].state !== "DELETE")
                  .map((lKey, i) => (
                    <div className={styles.lookup} key={i}>
                      <div
                        style={{
                          marginRight: "10px",
                          maxWidth: "30%",
                          minWidth: "30%"
                        }}
                      >
                        <div className={styles.subItem}>{"Field"}</div>
                        <Select
                          options={Object.keys(dataset.fields).map((f) => ({
                            label: f,
                            value: f
                          }))}
                          defaultValue={{
                            label: filters[lKey].first,
                            value: filters[lKey].first
                          }}
                          ref={filters[lKey].state === "EDIT" ? "filterFieldOneEdit" : ""}
                          placeholder="Lookup Field"
                          isDisabled={filters[lKey].state !== "EDIT"}
                        />
                      </div>
                      <div
                        style={{
                          marginLeft: "10px",
                          maxWidth: "16%",
                          minWidth: "16%",
                          marginRight: "20px"
                        }}
                      >
                        <div className={styles.subItem}>{"Operator"}</div>
                        <Select
                          options={operations}
                          defaultValue={{
                            label: filters[lKey].operation,
                            value: filters[lKey].operation
                          }}
                          ref={filters[lKey].state === "EDIT" ? "filterOperationEdit" : ""}
                          placeholder="Matching Field"
                          isDisabled={filters[lKey].state !== "EDIT"}
                        />
                      </div>
                      <div style={{ maxWidth: "30%", minWidth: "30%" }}>
                        <LineInput
                          refs={filters[lKey].state === "EDIT" ? "filterFieldTwoEdit" : ""}
                          inputStyle={{ marginTop: "5px" }}
                          isMediumBox
                          isDisabled={filters[lKey].state !== "EDIT"}
                          defaultValue={filters[lKey].second}
                        />
                      </div>
                      {filters[lKey].state !== "EDIT" ? (
                        <ButtonGroup>
                          <Button
                            onClick={() =>
                              updateFilter(lKey, {
                                ...filters[lKey],
                                state: "EDIT"
                              })
                            }
                          >
                            {"Edit"}
                          </Button>
                          <Button
                            onClick={() =>
                              updateFilter(lKey, {
                                ...filters[lKey],
                                state: "DELETE"
                              })
                            }
                          >
                            {"Delete"}
                          </Button>
                        </ButtonGroup>
                      ) : (
                        <ButtonGroup>
                          <Button
                            onClick={() => {
                              if (
                                this.refs.filterFieldOneEdit &&
                                this.refs.filterFieldOneEdit.state &&
                                this.refs.filterFieldOneEdit.state.value &&
                                this.refs.filterOperationEdit &&
                                this.refs.filterOperationEdit.state &&
                                this.refs.filterOperationEdit.state.value &&
                                this.refs.filterFieldTwoEdit &&
                                this.refs.filterFieldTwoEdit.state &&
                                this.refs.filterFieldTwoEdit.state.tempVal
                              ) {
                                updateFilter(lKey, {
                                  ...filters[lKey],
                                  first: this.refs.filterFieldOneEdit.state.value.value,
                                  operation: this.refs.filterOperationEdit.state.value.value,
                                  second: this.refs.filterFieldTwoEdit.state,
                                  state: "DONE"
                                });
                              }
                            }}
                          >
                            {"Save"}
                          </Button>
                          <Button
                            onClick={() =>
                              updateFilter(lKey, {
                                ...lookupKeys[lKey],
                                state: "DONE"
                              })
                            }
                          >
                            {"Cancel"}
                          </Button>
                        </ButtonGroup>
                      )}
                    </div>
                  ))}
              <div className={styles.lookup}>
                <div style={{ marginRight: "10px" }}>
                  <div className={styles.subItem}>{"Field"}</div>
                  <Select
                    options={Object.keys(dataset.fields).map((f) => ({
                      label: f,
                      value: f
                    }))}
                    ref="filterFieldOne"
                    placeholder="Select Field"
                  />
                </div>
                <div style={{ marginLeft: "10px" }}>
                  <div className={styles.subItem}>{"Operator"}</div>
                  <Select options={operations} ref="filterOperation" placeholder="operation" />
                </div>
                <div style={{ marginLeft: "10px" }}>
                  <div className={styles.subItem}>{"Input"}</div>
                  <LineInput ref={"filterFieldTwo"} isGalleryBox />
                </div>
              </div>
            </div>
            <div style={{ width: "100%", textAlign: "right", marginTop: "10px" }}>
              <Button
                onClick={() => {
                  if (
                    this.refs.filterFieldOne &&
                    this.refs.filterFieldOne.state &&
                    this.refs.filterFieldOne.state.value &&
                    this.refs.filterOperation &&
                    this.refs.filterOperation.state &&
                    this.refs.filterOperation.state.value &&
                    this.refs.filterFieldTwo &&
                    this.refs.filterFieldTwo.state &&
                    this.refs.filterFieldTwo.state.tempVal
                  ) {
                    const currentKeyLength = filters ? Object.keys(filters).length : 0;

                    updateFilter(currentKeyLength, {
                      index: currentKeyLength,
                      state: "DONE",
                      first: this.refs.filterFieldOne.state.value.value,
                      operation: this.refs.filterOperation.state.value.value,
                      second: this.refs.filterFieldTwo.state.tempVal
                    });
                  }
                }}
              >
                {"Add Filter"}
              </Button>
            </div>
          </div>
        </div>
        <div className={styles.rightFooterEdit}>
          <Button onClick={() => updateRightMode(GALLERY_RIGHT_MODE.EDIT)}>{"Back"}</Button>
          {isSaving ? (
            <LoadingIndicator style={{ margin: "0px" }} />
          ) : (
            <Button type="primary" onClick={() => saveChanges()}>
              {"Save Changes"}
            </Button>
          )}
        </div>
      </div>
    );
  }

  renderRightDerived() {
    const { isSaving, dataset, updateRightMode, saveChanges } = this.props;

    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{"Create Derived Variables"}</div>
        <div className={styles.rightContent}>
          <TransformContainer id={dataset.id} setupId={dataset.id} isMini />
        </div>
        <div className={styles.rightFooterEdit}>
          <Button onClick={() => updateRightMode(GALLERY_RIGHT_MODE.EDIT)}>{"Back"}</Button>
          {isSaving ? (
            <LoadingIndicator style={{ margin: "0px" }} />
          ) : (
            <Button type="primary" onClick={() => saveChanges()}>
              {"Save Changes"}
            </Button>
          )}
        </div>
      </div>
    );
  }

  renderRightFeedback() {
    const { dataset } = this.props;

    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{"Annotate"}</div>
        <div className={styles.rightContent}>
          <FeedbackContainer id={dataset.id} hideTags />
        </div>
      </div>
    );
  }

  getActiveBlueprint() {
    const { columnBlueprintId, blueprints } = this.props;

    const activeBlueprint = columnBlueprintId && blueprints && blueprints.find((b) => b.id === columnBlueprintId);

    return activeBlueprint;
  }

  getActiveMatchedColumns() {
    const { id } = this.props;
    const blueprint = this.getActiveBlueprint();
    return blueprint && blueprint.wizard && blueprint.wizard.linkedDatasets && blueprint.wizard.linkedDatasets[id];
  }

  renderBlueprintSelect() {
    const {
      dataset,
      blueprints,
      isBlueprintSaving,
      updateColumnBlueprintId,
      updateIsBlueprintSaved,
      saveBlueprintMatches,
      isBlueprintSaved,
      history,
      isConsumer,
      canManagePermissions
    } = this.props;

    let { isChangeBlueprint } = this.state;

    const activeBlueprint = this.getActiveBlueprint();

    const groupStyles = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    };

    const formatGroupLabel = (data) => (
      <div style={groupStyles}>
        <span>{"Name"}</span>
        <span>{"Matches"}</span>
      </div>
    );

    const selectedBlueprint = activeBlueprint ? { label: activeBlueprint.name, value: activeBlueprint.id } : null;

    return (
      <React.Fragment>
        <div
          className={styles.blueprintSelect + " " + styles.bpSelectHover}
          style={{
            display: isChangeBlueprint || !selectedBlueprint ? "none" : undefined
          }}
        >
          <div className={styles.bpSelectLink}>
            <img src={BlueprintIcon} className={styles.bIcon} />
            <a
              onClick={() =>
                selectedBlueprint
                  ? history.push("/eBlueprint/" + selectedBlueprint.value)
                  : this.setState({ isChangeBlueprint: true })
              }
            >
              {selectedBlueprint ? selectedBlueprint.label : "Select Blueprint"}
            </a>
          </div>
          {canManagePermissions ? (
            <div className={styles.blueprintActions}>
              <Button
                onClick={() => {
                  updateIsBlueprintSaved("saved");
                  this.setState({ isChangeBlueprint: true });
                }}
              >
                {"Edit"}
              </Button>
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          className={styles.blueprintSelect}
          style={{
            display: canManagePermissions && (isChangeBlueprint || !selectedBlueprint) ? undefined : "none"
          }}
        >
          {isConsumer !== true && (
            <div
              style={{
                width: "300px"
              }}
            >
              <Select
                options={[
                  {
                    label: (
                      <div className={styles.bpSelect}>
                        <div>{"Name"}</div>
                        <div>{"Field Matches"}</div>
                      </div>
                    ),
                    options:
                      blueprints &&
                      blueprints
                        .filter((b) => b.wizard && b.wizard.setup && b.wizard.setup.label)
                        .sort((a, b) => {
                          const aBP =
                            a.wizard.dataset && a.wizard.dataset.fields && dataset && dataset.fields
                              ? Object.keys(a.wizard.dataset.fields).filter((f) => dataset.fields[f] !== undefined)
                                  .length
                              : 0;
                          const bBP =
                            b.wizard.dataset && b.wizard.dataset.fields && dataset && dataset.fields
                              ? Object.keys(b.wizard.dataset.fields).filter((f) => dataset.fields[f] !== undefined)
                                  .length
                              : 0;

                          return aBP < bBP ? 1 : aBP > bBP ? -1 : 0;
                        })
                        .map((b) => ({
                          label: (
                            <div className={styles.bpSelect}>
                              <div>{b.wizard.setup.label}</div>
                              <div className={styles.bpSelectCount}>
                                {b.wizard.dataset && b.wizard.dataset.fields && dataset && dataset.fields
                                  ? Object.keys(b.wizard.dataset.fields).filter((f) => dataset.fields[f] !== undefined)
                                      .length
                                  : "0"}
                              </div>
                            </div>
                          ),
                          value: b.id
                        }))
                  }
                ]}
                value={selectedBlueprint}
                ref="blueprintSel"
                placeholder="Link Blueprint"
                onChange={(val) => {
                  updateIsBlueprintSaved(false);
                  updateColumnBlueprintId(val.value);
                  if (!isChangeBlueprint) {
                    this.setState({ isChangeBlueprint: true });
                  }
                }}
                formatGroupLabel={formatGroupLabel}
              />
            </div>
          )}
          {selectedBlueprint && (
            <div className={styles.blueprintActions}>
              <ButtonGroup>
                <Button
                  onClick={() => {
                    if (isBlueprintSaved === "saved") {
                      updateIsBlueprintSaved(true);
                    } else {
                      updateColumnBlueprintId(undefined);
                    }
                    this.setState({ isChangeBlueprint: false });
                  }}
                >
                  {"Cancel"}
                </Button>
                {isBlueprintSaving ? (
                  <LoadingIndicator />
                ) : (
                  <React.Fragment>
                    <Button
                      type="secondary"
                      onClick={() => {
                        saveBlueprintMatches(true);
                        this.setState({ isChangeBlueprint: false });
                      }}
                    >
                      {"Remove Link"}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        saveBlueprintMatches();
                        this.setState({ isChangeBlueprint: false });
                      }}
                    >
                      {"Apply Updates"}
                    </Button>
                  </React.Fragment>
                )}
              </ButtonGroup>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }

  renderRightField() {
    const { isNext, viewField, dataset, exploreOutcomes, analyzedOutcomes, outcomeSuccess } = this.props;

    const approvedList = [
      { label: "Min", value: "Min" },
      { label: "Max", value: "Max" },
      { label: "Mean", value: "Mean" },
      { label: "Standard Deviation", value: "Standard Deviation" },
      { label: "Observed Count", value: "Observed Count", isCount: true },
      { label: "Unique Count", value: "Unique Count", isCount: true },
      { label: "Missing Count", value: "Missing Count", isCount: true },
      { label: "Outlier Count", value: "Outlier Count", isCount: true }
    ];

    return (
      <div className={isNext ? styles.rightNext : styles.right} key={viewField ? viewField.label : "none"}>
        <div className={styles.rightHeader} style={{ marginBottom: "0px" }}>
          {viewField && viewField.label}
        </div>
        {!(analyzedOutcomes && analyzedOutcomes.length) && (
          <div style={{ margin: "10px 10px 20px" }}>{"Explore a column to generate statistics"}</div>
        )}
        <div className={styles.rightContentField}>
          <div
            className={styles.rightDist}
            style={
              this.state.showAllStats && this.state.showAllStats[viewField.label] === true ? { height: "380px" } : {}
            }
          >
            <div className={styles.statsTable}>
              <div className={styles.otHeader}>
                <div>{"Value"}</div>
                <div>{"Amount"}</div>
              </div>
              {viewField.type === "categorical" ||
              viewField.type === "date" ||
              this.state.showAllStats[viewField.label] === true ? (
                <div className={styles.otBody}>
                  {viewField &&
                    viewField.extraStats &&
                    Object.keys(viewField.extraStats)
                      .filter((k) => viewField.extraStats[k] !== undefined)
                      .map((k, i) => (
                        <div className={styles.outRow} key={i} style={{ paddingRight: "20px" }}>
                          <div style={{ textTransform: "capitalize" }}>{k}</div>
                          <div>
                            {isNaN(viewField.extraStats[k])
                              ? viewField.extraStats[k]
                              : k.indexOf("Count") !== -1
                                ? Math.round(viewField.extraStats[k])
                                : viewField.extraStats[k].toFixed(4)}
                          </div>
                        </div>
                      ))}
                </div>
              ) : (
                <div className={styles.otBody}>
                  {approvedList
                    .filter(
                      (item, i) =>
                        item.isCount !== true ||
                        (viewField && viewField.extraStats && viewField.extraStats[item.value] !== 0)
                    )
                    .map((item, i) => (
                      <div className={styles.outRow} key={i} style={{ paddingRight: "20px" }}>
                        <div>{item.label}</div>
                        <div>
                          {viewField &&
                          viewField.extraStats &&
                          !isNaN(viewField.extraStats[item.value]) &&
                          item.isCount !== true
                            ? viewField.extraStats[item.value].toFixed(4)
                            : Math.round(viewField.extraStats[item.value])}
                        </div>
                      </div>
                    ))}
                  <a
                    style={{ paddingLeft: "10px", marginTop: "10px" }}
                    onClick={() =>
                      this.setState({
                        showAllStats: {
                          ...this.state.showAllStats,
                          [viewField.label]: true
                        }
                      })
                    }
                  >
                    {"Show All"}
                  </a>
                </div>
              )}
            </div>
          </div>
          <div className={styles.bottomCharts}>
            {exploreOutcomes !== undefined
              ? Object.keys(exploreOutcomes).map((o, i) => (
                  <div
                    style={{
                      height: "100%",
                      width: i === 0 ? "100%" : "100%",
                      marginTop: i === 0 ? "0px" : "20px"
                    }}
                    key={i}
                  >
                    <OutcomeChart
                      field={viewField}
                      dataset={dataset}
                      outcome={o}
                      outcomeSuccess={outcomeSuccess && o && outcomeSuccess[o] ? outcomeSuccess[o].value : undefined}
                      width={450}
                      showTitle
                    />
                  </div>
                ))
              : viewField &&
                viewField.outcomes &&
                Object.keys(viewField.outcomes).map((o, i) => (
                  <div
                    style={{
                      height: "100%",
                      width: i === 0 ? "100%" : "100%",
                      marginTop: i === 0 ? "0px" : "20px"
                    }}
                    key={i}
                  >
                    <OutcomeChart
                      field={viewField}
                      dataset={dataset}
                      outcome={o}
                      outcomeSuccess={outcomeSuccess && o && outcomeSuccess[o] ? outcomeSuccess[o].value : undefined}
                      width={450}
                      showTitle
                    />
                  </div>
                ))}
          </div>
        </div>
      </div>
    );
  }

  renderRightOutcome() {
    const { viewOutcome } = this.props;

    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{viewOutcome && viewOutcome.label}</div>
        <div className={styles.rightContent}></div>
        <div className={styles.rightFooter}></div>
      </div>
    );
  }

  renderRightAIReady() {
    const { dataset } = this.props;

    let { selectedOutcomes } = this.state;

    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{"AI Readiness"}</div>
        <div className={styles.rightContent}>
          <div className={styles.rightInfo}>
            {"Select the variables you would like to predict and " +
              "Aible will evaluate if they are AI ready. If a column " +
              "is AI ready the coumns with predictive signal will be listed below."}
          </div>
          <div className={styles.normalBold} style={{ marginTop: "30px" }}>
            {"Which variables would you like to predict?"}
          </div>
          <div className={styles.outcomeTable}>
            <div className={styles.otHeader}>
              <div>{"Variable"}</div>
              <div>{"Selected"}</div>
            </div>
            <div className={styles.otBody}>
              {dataset &&
                dataset.fields &&
                Object.keys(dataset.fields).map((f, i) => (
                  <div
                    className={styles.outRow + " " + (selectedOutcomes[f] === true ? styles.outRowSelected : "")}
                    onClick={() =>
                      this.setState({
                        selectedOutcomes: {
                          ...selectedOutcomes,
                          [f]: selectedOutcomes[f] !== true
                        }
                      })
                    }
                    key={i}
                  >
                    {f}
                    {selectedOutcomes[f] === true && <img src={CheckIcon} style={{ marginRight: "10px" }} />}
                  </div>
                ))}
            </div>
          </div>
          <Button style={{ marginTop: "20px" }}>{"Evaluate AI Readiness"}</Button>
        </div>
        <div className={styles.rightFooter}>
          <Button type="primary">{"Create AI with Aible"}</Button>
        </div>
      </div>
    );
  }

  renderRightEdit() {
    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{"Edit Data"}</div>
        <div className={styles.rightContent}></div>
        <div className={styles.rightFooter}></div>
      </div>
    );
  }

  renderRightPanel() {
    const { isNext, activeTab, rightMode, updateRightMode, updateViewField } = this.props;

    return isNext && activeTab !== "DETAIL" ? (
      <div />
    ) : (
      <div
        className={activeTab === "DETAIL" ? styles.rightPanel : styles.rightLeft}
        style={{
          width:
            rightMode === undefined
              ? "0px"
              : rightMode === GALLERY_RIGHT_MODE.EXPLORE ||
                  // rightMode === GALLERY_RIGHT_MODE.FIELD ||
                  rightMode === GALLERY_RIGHT_MODE.OUTCOME
                ? "900px"
                : rightMode === GALLERY_RIGHT_MODE.DERIVED || rightMode === GALLERY_RIGHT_MODE.FILTER
                  ? "750px"
                  : rightMode === GALLERY_RIGHT_MODE.COMBINE || rightMode === GALLERY_RIGHT_MODE.APPEND
                    ? "550px"
                    : "400px",
          overflow: rightMode === undefined ? "hidden" : "visible"
        }}
      >
        <Button
          className={isNext ? styles.rightCloseNext : styles.rightClose}
          onClick={() => {
            updateRightMode(undefined);
            updateViewField(undefined);
          }}
          style={{ padding: "7px" }}
        >
          <FontAwesomeIcon icon={faTimes} style={{ marginRight: "5px" }} />
          {"Close"}
        </Button>
        {rightMode === GALLERY_RIGHT_MODE.LINEAGE ? (
          this.renderRightLineage()
        ) : rightMode === GALLERY_RIGHT_MODE.EXPLORE ? (
          this.renderRightExplore()
        ) : rightMode === GALLERY_RIGHT_MODE.AIREADY ? (
          this.renderRightAIReady()
        ) : rightMode === GALLERY_RIGHT_MODE.EDIT ? (
          this.renderRightEdit()
        ) : rightMode === GALLERY_RIGHT_MODE.FIELD ? (
          this.renderRightField()
        ) : rightMode === GALLERY_RIGHT_MODE.OUTCOME ? (
          this.renderRightOutcome()
        ) : rightMode === GALLERY_RIGHT_MODE.COMBINE ? (
          this.renderRightCombine()
        ) : rightMode === GALLERY_RIGHT_MODE.APPEND ? (
          this.renderRightAppend()
        ) : rightMode === GALLERY_RIGHT_MODE.FILTER ? (
          this.renderRightFilter()
        ) : rightMode === GALLERY_RIGHT_MODE.DERIVED ? (
          this.renderRightDerived()
        ) : rightMode === GALLERY_RIGHT_MODE.FEEDBACK ? (
          this.renderRightFeedback()
        ) : (
          <div />
        )}
      </div>
    );
  }

  renderViewChart() {
    const {
      addChartId,
      updateAddChartId,
      dataset,
      outcomeSuccess,
      createReport,
      reports,
      addChartToReport,
      isConsumer
    } = this.props;
    const { viewChart, isScaled, isLoadingAddChart } = this.state;

    return (
      <Dialog open={viewChart !== undefined} onOpenChange={() => this.setState({ viewChart: undefined })}>
        <DialogContent size="xl">
          <div className={styles.outcomeChartLarge}>
            {viewChart && viewChart.field ? (
              <div className={styles.modalChartHolder}>
                <div
                  style={{
                    height: "calc(100% - 40px)",
                    width: addChartId !== undefined || isLoadingAddChart ? "calc(100% - 320px)" : "100%"
                  }}
                >
                  {viewChart.type === "Outcome" ? (
                    <OutcomeChart
                      field={viewChart.field}
                      dataset={dataset}
                      outcome={viewChart.outcome}
                      outcomeSuccess={
                        outcomeSuccess && viewChart.outcome && outcomeSuccess[viewChart.outcome]
                          ? outcomeSuccess[viewChart.outcome].value
                          : undefined
                      }
                      showCorrelation
                      isScaled={this.state.scaled[viewChart.outcome]}
                      showAxis
                      showTitle
                    />
                  ) : (
                    <DistributionChart field={viewChart.field} showAxis showTitle />
                  )}
                </div>
                <div
                  className={styles.addReportActions}
                  style={
                    addChartId !== undefined
                      ? { position: "relative" }
                      : isLoadingAddChart
                        ? {
                            position: "relative",
                            display: "flex",
                            justifyContent: "center"
                          }
                        : {}
                  }
                >
                  {isConsumer ? (
                    <React.Fragment />
                  ) : isLoadingAddChart === true ? (
                    <div className={styles.chartLoading} style={{ fontSize: "22px" }}>
                      {"Adding Chart..."}
                      <LoadingIndicator style={{ margin: "10px" }} />
                    </div>
                  ) : (
                    <div>
                      <div className={styles.addToReport}>
                        <Select
                          placeholder="Select Report"
                          options={[
                            { label: "Create New Report", value: "CREATE" },
                            ...reports.map((r) => ({
                              label: r.name,
                              value: r.id
                            }))
                          ]}
                          defaultValue={addChartId}
                          onChange={(val) => updateAddChartId(val)}
                        />
                      </div>
                      {addChartId && addChartId.value === "CREATE" ? (
                        <div className={styles.addReportButtons}>
                          <div className={styles.addSubItem}>{"Name"}</div>
                          <LineInput
                            defaultValue={
                              dataset
                                ? dataset.label + " " + moment.utc(new Date()).local().format("MMMM Do YYYY, h:mm:ss a")
                                : "New Report"
                            }
                            isMediumBox
                            ref={"reportName"}
                          />
                          <Button
                            style={{ marginTop: "20px" }}
                            onClick={() => {
                              this.setState({ isLoadingAddChart: true });

                              const reportName =
                                this.refs["reportName"] && this.refs["reportName"].state
                                  ? this.refs["reportName"].state.tempVal
                                  : "New Report";

                              createReport(reportName, {
                                field: viewChart.field,
                                type:
                                  viewChart.type === "Outcome"
                                    ? REPORT_CHART_TYPES.OUTCOME
                                    : REPORT_CHART_TYPES.DISTRIBUTION,
                                outcome: viewChart.outcome,
                                outcomeSuccess:
                                  outcomeSuccess && viewChart.outcome && outcomeSuccess[viewChart.outcome]
                                    ? outcomeSuccess[viewChart.outcome].value
                                    : undefined,
                                isScaled: this.state.scaled[viewChart.outcome],
                                title:
                                  viewChart.type === "Outcome" && viewChart.outcome
                                    ? viewChart.field.label + " by " + viewChart.outcome
                                    : viewChart.field.label + " Distribution",
                                showAxis: true,
                                showTitle: true
                              });

                              return setTimeout(() => {
                                this.setState({ isLoadingAddChart: false });
                              }, 500);
                            }}
                          >
                            {"Create Report"}
                          </Button>
                        </div>
                      ) : (
                        addChartId !== undefined && (
                          <Button
                            style={{ marginTop: "20px" }}
                            onClick={() => {
                              this.setState({ isLoadingAddChart: true });

                              addChartToReport(addChartId.value, {
                                field: viewChart.field,
                                type:
                                  viewChart.type === "Outcome"
                                    ? REPORT_CHART_TYPES.OUTCOME
                                    : REPORT_CHART_TYPES.DISTRIBUTION,
                                outcome: viewChart.outcome,
                                outcomeSuccess:
                                  outcomeSuccess && viewChart.outcome && outcomeSuccess[viewChart.outcome]
                                    ? outcomeSuccess[viewChart.outcome].value
                                    : undefined,
                                isScaled: this.state.scaled[viewChart.outcome],
                                title:
                                  viewChart.type === "Outcome" && viewChart.outcome
                                    ? viewChart.field.label + " by " + viewChart.outcome
                                    : viewChart.field.label + " Distribution",
                                showAxis: true,
                                showTitle: true
                              });

                              return setTimeout(() => {
                                this.setState({ isLoadingAddChart: false });
                              }, 500);
                            }}
                          >
                            {"Add To Report"}
                          </Button>
                        )
                      )}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              viewChart &&
              viewChart.field && (
                <OutcomeChart
                  height={600}
                  width={1000}
                  dataset={dataset}
                  field={viewChart.field}
                  outcome={viewChart.outcome}
                  outcomeSuccess={
                    outcomeSuccess && viewChart.outcome && outcomeSuccess[viewChart.outcome]
                      ? outcomeSuccess[viewChart.outcome].value
                      : undefined
                  }
                  showCorrelation
                  isScaled={this.state.scaled[viewChart.outcome]}
                />
              )
            )}
          </div>
          <DialogFooter>
            <Button type="secondary" onClick={() => this.setState({ viewChart: undefined })}>
              {"Close"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }

  renderBuyModal() {
    const { isBuyAible } = this.state;

    return (
      <div id="buyModal">
        <Dialog open={isBuyAible === true} onHide={() => this.setState({ isBuyAible: false })}>
          <DialogContent size="sm">
            <DialogHeader>
              <DialogTitle>{"Upgrade Aible to Continue"}</DialogTitle>
            </DialogHeader>

            <div className={styles.buyAibleContent}>
              <img src={ABIcon} style={{ margin: "0px auto 20px" }} />
              <div>
                {"You need to have an Aible Business or Aible Advanced account " +
                  "to start creating AI models with this dataset."}
              </div>
              <div style={{ marginTop: "20px" }}>{"Contact Aible today to start building AI."}</div>
            </div>
            <DialogFooter>
              <Button
                type="secondary"
                onClick={() => this.setState({ isBuyAible: false })}
                style={{ marginRight: "auto" }}
              >
                {"Close"}
              </Button>
              <a href="https://www.aible.com/contact-us/" target="_blank">
                <Button type="primary" onClick={() => this.setState({ isBuyAible: false })}>
                  {"Contact Aible"}
                </Button>
              </a>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  render() {
    const { dataset, isConsumer, isNext, isAdvanced } = this.props;

    return dataset === undefined ? (
      <LoadingIndicator />
    ) : (
      <div
        className={
          isNext
            ? styles.gallery
            : isAdvanced
              ? styles.galleryAdvanced
              : isConsumer
                ? styles.galleryConsumer
                : styles.gallery
        }
      >
        {this.renderRightPanel()}
        {this.renderHeader()}
        {this.renderTable()}
        {this.renderViewChart()}
        {this.renderBuyModal()}
      </div>
    );
  }
}
